'use strict';

/** @type {import('./isPropertyKey')} */
module.exports = function isPropertyKey(argument) {
	return typeof argument === 'string' || typeof argument === 'symbol';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract-get/isPropertyKey.js
 ** module id = 563
 ** module chunks = 0
 **/